import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  titleContainer: {
    marginBottom: "20px",
  },
  cardContent: {
    padding: 0,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: theme.palette.primary,
  },
  totalPrice: {
    fontSize: 16,
    fontWeight: 600,
    color: "#5D3EBD",
  },
  avatar: {
    width: theme.spacing(5),
    height: theme.spacing(5),
  },
}));
